import React from 'react';
import axios from 'axios';

import ChooseRegionForAttachAM from './ChooseRegionForAttachAM';
import AgreedAMsForCase from './ListOfAMsAfterMailing';
import CardOfUser from '../CardOfUser';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import { formatDate } from '../../Utils/GlobalUtils';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

const AMPanel = ({ id, workerId, mailingStatus, phaseId, userDetails, dateCourt, dateSubmissionCandidate, dateAmAppointment, onAMPanelSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [isCardOfUser, setIsCardOfUser] = React.useState('');
    const [currentAMId, setCurrentAMId] = React.useState('');

    const [loading, setLoading] = React.useState(false);

    const [confirming, setConfirming] = React.useState(false); // Кнопка Открепить

    // Сброс состояния подтверждения через 3 секунды
    React.useEffect(() => {
        let timer;
        if (confirming) {
            timer = setTimeout(() => setConfirming(false), 3000);
        }
        return () => clearTimeout(timer);
    }, [confirming]);

    // Открепить арбитражного управляющего от дела
    const removeAMFromCase = () => {
        setLoading(true);
        axios.put(`/api/remove-AM-from-case?caseId=${id}`)
        .then(() => {
            openTimeModal('Арбитражный управляющий откреплен', 'success');
        })
        .catch(() => {
            openTimeModal('Не удалось открепить арбитражного управляющего', 'error');
        })
        .finally(() => {
            onAMPanelSuccess();
            setLoading(false);
        })
    };

    const handleClick = () => {
        if (confirming) {
            removeAMFromCase();
        } else {
            setConfirming(true);
        }
    };

    const [isAddDateSubmissionCandidate, setIsAddDateSubmissionCandidate] = React.useState(false);
    const [newDateSubmissionCandidate, setNewDateSubmissionCandidate] = React.useState('');

    const addNewDateSubmissionCandidate = () => {
        setLoading(true);
        axios.put(`/api/add-new-date-submission-candidate`, {
            caseId: id,
            dateSubmissionCandidate: newDateSubmissionCandidate
        })
        .then(() => {
            openTimeModal('Дата отправки кандидатуры в суд добавлена в карточку', 'success');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal('Не удалось добавить дату отправки кандидатуры в суд. Попробуйте позднее', 'error');
        })
        .finally(() => {
            onAMPanelSuccess();
            setLoading(false);
        })
    };

    const [isAddDateAmAppointment, setIsAddDateAmAppointment] = React.useState(false);
    const [newDateAmAppointment, setNewDateAmAppointment] = React.useState('');

    const addNewDateAmAppointment = () => {
        setLoading(true);
        axios.put(`/api/add-new-date-am-appointment`, {
            caseId: id,
            dateAmAppointment: newDateAmAppointment
        })
        .then(() => {
            openTimeModal('Дата назначения арбитражного управляющего добавлена в карточку', 'success');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal('Не удалось добавить дату назначения арбитражного управляющего. Попробуйте позднее', 'error');
        })
        .finally(() => {
            onAMPanelSuccess();
            setLoading(false);
        })
    };

    return (
        <>
            {isCardOfUser && <CardOfUser closeModal={() => {setIsCardOfUser(false)}} id={currentAMId} />}

            <h2>Арбитражный управляющий:</h2>
            <div className={styles.outliningPanel}>
            {!phaseId || !workerId ? (
                <a>
                    Для назначения арбитражного управляющего необходимо, чтобы за карточкой был закреплён работник СОАУ и выбран этап исполнения.
                </a>
            ) : (
                mailingStatus === "Письма не отправлены" ? (
                    <ChooseRegionForAttachAM idCase={id} onMailingSuccess={onAMPanelSuccess} />
                ) : mailingStatus === "Письма отправлены" ? (
                    <AgreedAMsForCase idCase={id} onAppointmentSuccess={onAMPanelSuccess} />
                ) : mailingStatus === "Дело присвоено" ? (
                    <>
                        {userDetails == null ? (
                            <>
                                <a className={styles.statusPanel}>
                                    <img src='/img/icons/warning-icon.svg' alt='Предупреждение' />
                                    Произошла ошибка: учётная запись арбитражного управляющего не найдена в системе «Поток». Возможно, она была удалена по запросу.
                                </a>
                            </>
                        ) : (
                            <>
                                <a>
                                    {!dateAmAppointment ? 
                                        "Выбран СОАУ:"
                                        :
                                        "Назначен Арбитражным судом:"
                                    }
                                </a>
                                <div className={styles.outliningPanel}>
                                    <a onClick={() => {setIsCardOfUser(true); setCurrentAMId(workerId)}} style={{cursor: 'pointer'}}>
                                        {userDetails?.lastname} {userDetails?.firstname} {userDetails?.surname}
                                    </a>
                                    <a href={`mailto:${userDetails?.email}`} className={styles.aWithLink}>
                                        {userDetails?.email}
                                    </a>
                                    {dateSubmissionCandidate && 
                                        <a className={styles.description} style={{ margin: '2px 0 0 0' }}>
                                            Выбран: {formatDate(dateSubmissionCandidate)}
                                        </a>
                                    }
                                    {dateCourt && 
                                        <a className={styles.description} style={{ margin: '2px 0 0 0' }}>
                                            Дата судебного заседания о назначении: {formatDate(dateCourt)}
                                        </a>
                                    }
                                    {dateAmAppointment && 
                                        <a className={styles.description} style={{ margin: '2px 0 0 0' }}>
                                            Назначен: {formatDate(dateAmAppointment)}
                                        </a>
                                    }
                                    {loading ? (
                                        <Loading />
                                    ) : (
                                        <button type='button' className='miniButton' style={{margin: '7px 0px 0px'}} onClick={handleClick}>
                                            {confirming
                                            ? 'Вы уверены, что хотите открепить?'
                                            : 'Открепить арбитражного управляющего'}
                                        </button>
                                    )}
                                </div>

                                {!dateSubmissionCandidate ? 
                                    !isAddDateSubmissionCandidate ?
                                        <div className={styles.outliningPanel}>
                                            <a className='description'>Арбитражный управляющий выбран СОАУ и закреплен за данной карточкой. Теперь укажите дату отправки кандидатуры в суд</a>
                                            <button type='button' className='button' onClick={() => {setIsAddDateSubmissionCandidate(true)}}>Указать дату отправки кандидатуры в суд</button>
                                        </div>
                                    :
                                    <div className={styles.outliningPanel}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                                            <h2 style={{margin: '0', width: '80%'}}>Добавьте дату отправки кандидатуры в суд</h2>
                                            <img src='/img/icons/close-x.svg' alt='X' style={{width: '20px', cursor: 'pointer'}} onClick={() => {setIsAddDateSubmissionCandidate(false)}} />
                                        </div>
                                        <a>Укажите дату</a>
                                        <input type='date' value={newDateSubmissionCandidate} onChange={(e) => setNewDateSubmissionCandidate(e.target.value)} required />
                                        <button type='button' className='button' onClick={() => {addNewDateSubmissionCandidate()}}>Подтвердить</button>
                                    </div>
                                : !dateAmAppointment ?
                                    !isAddDateAmAppointment ?
                                    <div className={styles.outliningPanel}>
                                        <a className='description'>По итогу заседания Арбитражного суда в случае назначения арбитражного управляющего необходимо указать дату назначения. В ином случае принудительно закройте карточку</a>
                                        <button type='button' className='button' onClick={() => {setIsAddDateAmAppointment(true)}}>Указать дату назначения</button>
                                    </div>
                                    :
                                    <div className={styles.outliningPanel}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                                            <h2 style={{margin: '0', width: '80%'}}>Добавьте дату назначения арбитражного управляющего</h2>
                                            <img src='/img/icons/close-x.svg' alt='X' style={{width: '20px', cursor: 'pointer'}} onClick={() => {setIsAddDateAmAppointment(false)}} />
                                        </div>
                                        <a>Укажите дату</a>
                                        <input type='date' value={newDateAmAppointment} onChange={(e) => setNewDateAmAppointment(e.target.value)} required />
                                        <button type='button' className='button' onClick={() => {addNewDateAmAppointment()}}>Подтвердить</button>
                                    </div>
                                : <></>}
                            </>
                        )}
                    </>
                ) : (
                    <a>Не удалось загрузить компонент</a>
                )
            )}
            </div>
        </>
    )
}

export default AMPanel;